import { Routes, Route } from "react-router-dom"
import { HardRefresh } from "source/shared/routingUtils"
import { DonationForm } from "./donate/form"
import { DonationThankYou } from "./donate/thank_you"
import { DonationFailure } from "./donate/failure"
import { Profile } from "./profile"
import { DonationProcessing } from "./donate/processing"
import { useSuspenseQuery } from "@tanstack/react-query"
import { fetchFlagsQuery } from "./queries"
import {
  GivingOrganizationProvider,
  useGivingOrganizationContext,
} from "./profile/hooks/useGivingOrganizationContext"
import { OrganizationNotAcceptingDonations } from "./components/OrganizationNotAcceptingDonations"

export function Giving() {
  return (
    <GivingOrganizationProvider>
      <RenderRoutes />
    </GivingOrganizationProvider>
  )
}

function RenderRoutes() {
  const { data: flags } = useSuspenseQuery(fetchFlagsQuery())
  const { givingOrganization } = useGivingOrganizationContext()

  const urlParams = new URLSearchParams(window.location.search)
  if (urlParams.get("app_guest_mode") === "true") {
    sessionStorage.setItem("app_guest_mode", "true")
  }

  const showDonationForm = flags.monorepo_donation_form
  const showMyGiving = flags.monorepo_my_giving

  if (!showDonationForm && !showMyGiving) {
    return <HardRefresh />
  }

  if (!givingOrganization?.accepting_donations) {
    return <OrganizationNotAcceptingDonations />
  }

  return (
    <Routes>
      <Route path="*" element={<HardRefresh />} />
      {showDonationForm && (
        <>
          <Route path="/" element={<DonationForm />} />
          <Route path="/to/:fundSlug" element={<DonationForm />} />
          <Route path="/donation_thank_you" element={<DonationThankYou />} />
          <Route path="/donation_failure" element={<DonationFailure />} />
          <Route path="/donation_processing" element={<DonationProcessing />} />
        </>
      )}
      {showMyGiving && <Route path="/profile/*" element={<Profile />} />}
    </Routes>
  )
}
